import { translate } from '../../utils';
import { PERIOD_OPTIONS } from './portfolioDashboardUtilities';

/** @param {{ period: import('./portfolioDashboard.types').PortfolioPeriod, onChange: function(string): void }} props */
export const PortfolioPeriodPicker = function PortfolioPeriodPicker({ period, onChange }) {
    const handleChange = (event) => {
        onChange(event.target.value);
    };

    return (
        <div className="box box-solid">
            <div className="box-body">
                <div className="hstack gap-3">
                    <h4 className="mb-0">
                        {translate('frontend', 'PORTFOLIO_DASHBOARD_PERIOD')}
                    </h4>

                    <select
                        className="form-control w-auto"
                        value={period}
                        onChange={handleChange}
                    >
                        {PERIOD_OPTIONS.map((periodOption) => (
                            <option
                                key={periodOption.value}
                                value={periodOption.value}
                            >
                                {translate('frontend', periodOption.labelTranslationKey)}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};
